const getFiltersForSlider = (responseFilters, takeoffLabel = 'takeoff', landingLabel = 'landing') => (!responseFilters ? {}
  : {
    [takeoffLabel]: responseFilters.takeOff,
    [landingLabel]: responseFilters.landing,
    filterTimeLayoverStart: responseFilters.startTimeLayover,
    filterTimeLayoverEnd: responseFilters.endTimeLayover,
    filterTimeLayoverMin: responseFilters.minTimeLayover,
    filterTimeLayoverMax: responseFilters.maxTimeLayover,
  });

export default getFiltersForSlider;
